import { Star } from '@material-ui/icons';
import { Color, Inline } from '@superdispatch/ui';
import { Box, TextBox } from '@superdispatch/ui-lab';
import styled from 'styled-components';

// We need white color for both themes
const WhiteStar = styled(Star)`
  color: ${Color.White};
`;

const WhiteTextBox = styled(TextBox)`
  color: ${Color.White};
`;

export function SuggestedByShipperTag() {
  return (
    <Box
      borderRadius="small"
      paddingLeft="xxsmall"
      paddingRight="xxsmall"
      backgroundColor="Yellow300"
    >
      <Inline space="xxsmall" verticalAlign="center" noWrap={true}>
        <WhiteStar fontSize="small" />
        <WhiteTextBox variant="body-semibold">
          Suggested by Shipper
        </WhiteTextBox>
      </Inline>
    </Box>
  );
}
